import { Avatar, Button, Card, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { routesGuest } from '../../../consts'
import { DELETED_USER_LABEL } from '../../../utils/deletedUserDisplay'

export function UserDeletedAccountStub() {
  const navigate = useNavigate()

  return (
    <Stack alignItems="center" justifyContent="center" minHeight="60vh" px={2}>
      <Card variant="primaryAdaptiveCard" sx={{ p: 3, maxWidth: 480, width: '100%' }}>
        <Stack gap={2} alignItems="center" textAlign="center">
          <Avatar sx={{ width: 72, height: 72, bgcolor: 'grey.400', fontSize: 24 }}>
            ?
          </Avatar>
          <Typography variant="black-16-semiBold">{DELETED_USER_LABEL}</Typography>
          <Typography variant="black-14-light" color="text.secondary">
            Этот профиль удалён и больше недоступен.
          </Typography>
          <Stack direction="row">
            <Button variant="follow" onClick={() => navigate(routesGuest.ROOT.path)}>
              На главную
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  )
}
